<template>
    <div>
        <Title>设计评审</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">阶段</div>
            <div class="value1">
                <DataDictFinder dictType="phase" :dictValue="extra.phaseCode" />
            </div>
            <div class="label">管理级别</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.manageLevel" :dictValue="extra.manageLevel" />
            </div>

            <div class="label">主持人</div>
            <div class="value1">{{ extra.hostName }}</div>
            <div class="label">记录人</div>
            <div class="value2">{{ extra.recorderName }}</div>

            <div class="label">项目负责人</div>
            <div class="value1">{{ extra.prjLeaderName }}</div>
            <div class="label">专业负责人</div>
            <div class="value2">{{ extra.majorLeaderNames }}</div>

            <div class="label">参会人员</div>
            <div class="value3">{{ extra.attendeeNames }}</div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
</style>
